import styled from 'styled-components';
import { Box, Heading, SubtleText } from '@99designs/emu';
import { spaces } from '@99designs/emu/settings';
import type { Image } from '../../types/Image';

export type HowItWorksStep = {
    title: string;
    description: string;
    image: Image | React.ReactNode;
};

const StepWrapper = styled(Box)`
    margin-right: ${spaces['1bu']};

    &:last-of-type {
        margin-right: 0;
    }
`;

export interface HowItWorksStepsProps {
    steps: HowItWorksStep[];
}

function isAnImage(image: Image | React.ReactNode): image is Image {
    return (image as Image).src !== undefined;
}

export function HowItWorksSteps({ steps }: HowItWorksStepsProps) {
    return (
        <Box display="flex" paddingTop="1.5bu">
            {steps.map((step: HowItWorksStep) => (
                <StepWrapper key={step.title} width="33.33%">
                    {isAnImage(step.image) ? (
                        <img src={step.image.src} alt={step.image.alt} />
                    ) : (
                        step.image
                    )}
                    <Heading appearanceLevel={6} accessibilityLevel={3} as="p">
                        {step.title}
                    </Heading>
                    <Box minHeight="60px">
                        <SubtleText>{step.description}</SubtleText>
                    </Box>
                </StepWrapper>
            ))}
        </Box>
    );
}
